<div class="attachments-container">
  @if (showUploader || (files && files.length > 0)) {
  <span class="attachments-label">{{ label }}</span>
  }
  <div class="full-width">
    <div class="container-box">
      <terra-uploader-block class="dashed-box h-full" [ngClass]="{'active': uploader.isDragover, 'hidden': !showUploader}" [multiple]="multiple"
        [accept]="acceptedFileTypes" #uploader>
        <div class="flex flex-row items-center gap-2">
          <mat-icon class="notranslate help-icon upload-icon m-auto material-symbols-rounded">arrow_circle_up</mat-icon>
          <span class="upload-trigger">Upload from your computer</span>
        </div>
      </terra-uploader-block>
    </div>
  </div>
  <div class="flex flex-column gap-2 full-width mb-4">
    @if (uploader.progress && uploader.progress !== 100) {
    <div class="progress-indicator">
      <div class="progress-title">
        <div>Processing</div>
        <div>{{ filesStatusTitle }}</div>
      </div>
      <mat-progress-bar color="secondary" mode="determinate" [value]="uploader.progress" />
    </div>
    }

    <table class="files-table gray-theme mat-elevation-z0">
      @for (item of sortedFiles; track $index) {
      <tr>
        <td width="55%">
          <button mat-button class="preview-button" aria-label="Preview File" type="button" (click)="openPreview(item)"
            [disableRipple]="true">
            <div class="file-label">
              <div class="file_type">
                <terra-document-file-icon [extension]="mediaTypeConverter(item.mediaType)" />
                @if (item.fileType === 3) {
                <img src="assets/images/logo/rent_manager_logo.png" class="file_type_logo" height="16px"
                  alt="Rent Manager logo" />
                }
              </div>
              {{truncateText(item.title)}}
            </div>
          </button>
        </td>
        <td>
          {{formatFileSize(item.sizeB)}}
        </td>
        <td>
          <div class="file-progress-indicator uploading-status">
            @if(item?.progress && item?.progress !== 100 && item?.progress !== -1) {
            <mat-progress-spinner [diameter]="20" [mode]="'determinate'" [value]="item.progress" />
            Uploading...
            }
            @if(item?.id || item?.progress == 100) {
            <mat-icon class="success">check_circle</mat-icon>
            {{ item.fileType === 3 ? 'Imported' : 'Uploaded' }}
            }
            @if(item?.progress == -1) {
            <mat-icon class="error">cancel</mat-icon>
            Failed
            }
          </div>
        </td>
        <td>
          <button mat-menu-item (click)="removeFile(item)" [disabled]="disabled">
            <mat-icon class="notranslate material-symbols-outlined">delete</mat-icon>
          </button>
        </td>
      </tr>
      }
    </table>
    <!-- Attachment size error -->
    @if (attachmentsSizeExceeded) {
    <div class="error-message validation-error flex flex-row items-center gap-2 mb-2">
      <mat-icon color="warn" class="notranslate">cancel</mat-icon>
      <span>The total size of all uploaded files must not exceed {{ maxTotalSize / (1024 * 1024) }}MB</span>
    </div>
    }
  </div>
</div>